import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.js';
import App from "./App";
import { BrowserRouter, Route, withRouter } from "react-router-dom";
import * as serviceWorker from "./serviceWorker";
import dotenv from "dotenv";
import { Switch } from "react-router-dom";


ReactDOM.render(<App/>,document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
